export default __webpack_public_path__ + "static/media/link-blue.2ff042f3.svg";